module.exports = __webpack_public_path__ + "static/other/gameConstructionMaze.b7e5ec90.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameConstructionMaze.json
// module id = 2571
// module chunks = 0